import constants from './constants';

const setCreateEditClient = (values) => (dispatch) => {

  dispatch({
    type: constants.SET_CREATE_EDIT_CLIENT,
    payload: values,
  });

};

const setClientIdEdit = (values) => (dispatch) => {

  dispatch({
    type: constants.SET_CLIENT_ID_TO_EDIT,
    payload: values,
  });

};

const setViewClient = (values) => (dispatch) => {

  dispatch({
    type: constants.SET_VIEW_CLIENT,
    payload: values,
  });

};

const setDashboardClient = (values) => (dispatch) => {

  dispatch({
    type: constants.SET_DASHBOARD_CLIENT,
    payload: values,
  });

};

export default {
  setCreateEditClient,
  setClientIdEdit,
  setViewClient,
  setDashboardClient,
};
